import { render, staticRenderFns } from "./ConfirmEmailChange.vue?vue&type=template&id=d0ab6258&"
import script from "./ConfirmEmailChange.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmailChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports